import { actions } from "react-redux-form";
import { httpDownload, httpPost } from "../../../../utils/api.utils";
import {
    setArticleUploadError
    , getArticleUploadTypes
    , ArticleUploadModel
} from "../../../../constants/model-reducers/external/recharge/article-catalogue/article-upload.settings";

export const articleUploadFormInitialState = ArticleUploadModel;

const defaultState = () => ({
    articleUploadTypeOptions: [],
    articleUploadError: false
});

const initialState = defaultState();

export const ArticleUploadTypeAction = {
    getArticleUploadTypes: () => async (dispatch, state) => {
        var res = await httpPost('external/recharge/getArticleUploadTypeList');

        if (res.ok === false) {
            dispatch({
                type: setArticleUploadError,
                hrUploadError: false,
                hrUploadTypeOptions: []
            })
        }
        else {
            dispatch({
                type: getArticleUploadTypes,
                data: res
            });
        }
    },

    onArticleUploadTypeSelect: (model, value) => async (dispatch, state) => {
        const intValue = parseInt(value);

        dispatch(actions.change(model, value));
        dispatch(actions.change("articleUploadForm.articleUploadTypeId", intValue))
    },

    postExecuteProcess: (UploadId) => () => {
        var url = 'external/adminupload/executePackage';

        httpPost(url, UploadId);
    },

    resetArticleUploadForm: () => async (dispatch, state) => {
        dispatch(actions.reset('articleUploadForm.articleUploadTypeId'));
    },

    downloadArticleCatalogueTemplate: (fileAttachmentModule, fileName) => async (dispatch, getState) => {
        const encodedFileName = encodeURIComponent(fileName);

        const dealName = sessionStorage.getItem('DealName');
        const newFileName = `ATEM ${dealName} - Article Catalogue Template.xlsx`;

        try {
            const response = await httpDownload(`common/fileAttachment/downloadFile/${fileAttachmentModule}/${encodedFileName}`);
            if (response.ok) {
                response.blob().then(function (blob) {
                    let downloadUrl = window.URL.createObjectURL(blob);
                    let a = document.createElement('a');
                    if (window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveOrOpenBlob(blob, newFileName);
                    } else {
                        a.href = downloadUrl;
                        a.download = newFileName;
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                    }
                });
            } else {
                dispatch({
                    type: setArticleUploadError,
                    hrUploadError: false,
                })
            }
        } catch (error) {
            dispatch({
                type: setArticleUploadError,
                hrUploadError: false,
            })
        }
    }
}

export const reducer = (state, action) => {
    state = state || initialState;
    switch (action.type) {
        case getArticleUploadTypes:
            return {
                ...state,
                articleUploadTypeOptions: action.data
            }
        default:
            return state
    }
}